<template>
  <div id="page-Settle" class="d-flex">
    <MainBarMenu />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <div class="layout-content container-fluid div1 mt-5">
        <div class="layout-content container-fluid mt-5">
          <div class="row">
            <div class="col-12">
              <h2 class="mt-0 mt-md-3 mt-lg-4">Solicitudes</h2>
              <!-- .col -->
              <div class="col-12 col-md-0 text-left text-lg-right">
                <div class="cont-search d-flex flex-column align-items-start align-items-md-end">
                  <label for="filter d-block">Ingresa palabra clave</label>
                  <div class="cont-input d-flex">
                    <input
                      type="text"
                      class="input-text"
                      v-model="datatable.filter"
                      placeholder="Introduce tu búsqueda..."
                      @keyup="$event.stopImmediatePropagation(),getFilterDp()"
                    />
                    <button
                      class="d-flex align-items-center px-3">
                      <span>Buscar</span>
                      <span class="icon icon-search ml-3"></span>
                    </button>
                  </div>
                </div>
              </div>
              <!-- .col -->
              <div v-if="user.core_role_id != '1'">
      <b-card no-body class="mb-1 my-5" style="background: #E9ECEE">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button class="button1" block v-b-toggle.accordion-1 variant="info">
            Filtros avanzados
            <span class="when-opened">                            
              <img class="centerImg1" src="@/assets/images/icons/chevron-up.svg">
            </span>
            <span class="when-closed">
              <img class="centerImg1" src="@/assets/images/icons/chevron-down.svg">
            </span>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-1"  accordion="my-accordion" role="tabpanel" align="left">
          <b-card-body>
            <table class="tabla1" border="0" width="100%">
              <thead>
                <tr>
                  <td class="td1 text-left">Filtrar por Id</td>                 
                  <td class="td1 text-left">Filtrar por estado</td>
                  <td class="td1 text-left">Reporte</td>
                </tr>
                <!-- Filtro por Id -->
                <tr>
                  <td class="td2">
                    <div class="custom-control custom-radio">
                      <input 
                        class="custom-control-input"
                        type="radio"
                        v-model="filterDP.id"
                        v-on:change="getFilterDp"
                        :value="true"
                        id="Check1"
                        >
                      <label class="custom-control-label" for="Check1">
                        <p>Mis derechos de Petición</p>
                      </label>
                    </div>
                    <div class="custom-control custom-radio">
                      <input 
                        class="custom-control-input"
                        type="radio"
                        v-model="filterDP.id"
                        v-on:change="getFilterDp"
                        :value="false"
                        id="Check2"
                        >
                      <label class="custom-control-label" for="Check2">
                        <p>Todos los Derechos Petición</p>
                      </label>
                    </div>
                  </td>

                  <!-- Filtro por Estado -->

                  <td class="td2 d-lg-flex flex-lg-wrap mt-lg-5">
                    
                    <div class="custom-control custom-checkbox col-lg-4">
                      <input 
                        class="custom-control-input"
                        type="checkbox"
                        v-model="filterDP.state"
                        v-on:change="getFilterDp"
                        value="pending"
                        id="Check4"
                        for="stateDP"
                        >
                      <label class="custom-control-label" for="Check4">
                        <p class="p2">
                          Pendiente
                          <img class="leftImg1" src="@/assets/images/icons/circle-clock.svg">
                        </p>
                      </label>
                    </div>
                    <div class="custom-control custom-checkbox col-lg-4">
                      <input 
                        class="custom-control-input"
                        type="checkbox"
                        v-model="filterDP.state"
                        v-on:change="getFilterDp"
                        value="open"
                        id="Check5"
                        for="stateDP"
                        >
                      <label class="custom-control-label" for="Check5">
                        <p class="p2">
                          Abierto
                          <img class="leftImg1" src="@/assets/images/icons/circle-clock.svg">
                        </p>
                      </label>
                    </div>
                    <div class="custom-control custom-checkbox col-lg-4">                    
                      <input 
                        class="custom-control-input"
                        type="checkbox"
                        v-model="filterDP.state"
                        v-on:change="getFilterDp"
                        value="closing"
                        id="Check6"
                        for="stateDP"
                        >
                      <label class="custom-control-label" for="Check6">
                        <p class="p2">
                          Cerrando
                          <img class="leftImg1" src="@/assets/images/icons/eye.svg">
                        </p>
                      </label>
                    </div>
                    <div class="custom-control custom-checkbox col-lg-4">
                      <input 
                        class="custom-control-input"
                        type="checkbox"
                        v-model="filterDP.state"
                        v-on:change="getFilterDp"
                        value="closed"
                        id="Check7"
                        for="stateDP"
                        >
                      <label class="custom-control-label" for="Check7">
                        <p class="p2">
                          Cerrado                    
                          <img class="leftImg1" src="@/assets/images/icons/circle-check.svg">
                        </p>
                      </label>
                    </div>
                  </td>

                  <!-- Reporte Consolidado -->
                  
                  <td>
                    <table class="tabla1" width="220px">
                        <tr>
                          <td class="td3">{{countAllDemands}} registros.</td>
                        </tr>
                        <tr>
                          <td class="td4">
                            <a :href="serverPath+'/petitionRightsExport'" download>
                              <img class="leftImg1" src="@/assets/images/icons/excel.svg">
                              <u> Reporte Consolidado DP</u>
                            </a>
                          </td>
                        </tr>
                    </table>
                  </td>
                </tr>
                </thead>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>
     </div>
              <!-- .row -->
              <div class="data-table row mt-5 mt-md-5">
                <div class="col-12">
                  <div v-if="loading" id="loader"></div>
                  <div v-else class="table-responsive">
                    <datatable
                      :columns="datatable.columns"
                      :data="datatable.rows"
                      :filter="datatable.filter"
                      :per-page="datatable.perPage"
                      :page="datatable.page"
                      sort="id:desc"
                    >
                      <template slot-scope="{ row, columns }">
                        <tr @click="funcion(row)">
                          <template>
                            <datatable-cell v-for="(column, j) in columns" 
                              :key="j" 
                              :column="column" 
                              :row="row">
                            </datatable-cell>
                          </template>
                        </tr>
                      </template>
                    </datatable>
                    <div class="col-12 cont-pagination my-5 d-flex justify-content-center">
                      <Pagination :data="rightPetition.data" @pagination-change-page="getFilterDp"></Pagination>
                      <!-- <datatable-pager v-model="datatable.page" type="short" :per-page="datatable.perPage"></datatable-pager> -->
                    </div>

                    <div class="cont-no-data" v-show="datatable.rows.length <= 0">
                      <div class="col-12 col-md-8 col-lg-7 mx-auto mt-3">
                        <img src="@/assets/images/demands/user-mail.svg" alt="user email" width="100%" />
                      </div>
                    </div>
                  </div>
                </div>
                <small v-show="error.flag" class="alert-danger">{{ error.message }}</small>
                <!-- .col-12 -->
                <div class="col-12 col-md-6 text-left cont-pagintation">
                  <p
                    class="text-1"
                  >Mostrando {{datatable.page}} - {{datatable.perPage}} de {{countAllDemands}} Solicitudes</p>
                </div>
                <!-- .col -->
                <div class="col-12 col-md-6 form-inline cont-pagintation text-left text-md-right">
                  <!--datatable-pager v-model="datatable.page" type="abbreviated" :per-page="datatable.perPage"></datatable-pager-->
                </div>
              </div>      
              <!-- .row -->
              <div class="mb-menu"></div>
            </div>        
          </div>
          <!-- .layout-content -->
        </div>
    </div>
  </div>
  <!-- #page-alldemands -->
</template>

<script>
import MainBarMenu from "@/components/layouts/MainBarMenu.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import { mapActions, mapState } from "vuex";
import serverConfig from "./../../services/config";
import Pagination from "laravel-vue-pagination";

export default {
  name: "listRP",
  components: {
    MainBarMenu,
    HeadingUser,
    Pagination
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      filterDP:{
        'id':false,
        'state':[],
        'page': 1
      },
      days: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
      monthNames: ["cero", "Ene", "Feb", "Mar", "Abr", "May", "Jun",
      "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
      msjModal: "",
      flagPath: "",
      nameFile: '',
      numSettled: '',
      ctgoria: '',
      opcionCategories: [],
      cont: 0,
      faqDetail: [],
      rightPetitionRows: [],
      tablas: [],
      datatable: {
        filter: "",
        perPage: 9,
        page: 1,
        columns: [
          {
            label: "ID Solicitud",
            field: "id",
            align: "left",
            sortable: true,            
            headerClass: "theading",
          },
          {
            label: "Fecha",
            field: "dateDP",
            align: "left",
            headerClass: "theading",
          },
          {
            label: "Categoria",
            field: "category",
            align: "left",
            headerClass: "theading",
          },
          {
            label: "Solicitante",
            field: "uploader",
            align: "left",
            headerClass: "theading",
          },
          {
            label: "Asignado",
            align: "left",
            headerClass: "theading",
            representedAs: ({subresponsable}) => `<span style="color:${subresponsable.color}">${subresponsable.text}</span>`,
            interpolate: true,
          },
          {
            label: "Estado",
            align: "left",
            headerClass: "theading",
            representedAs: ({ status }) =>
              `<span class="icon icon-${status.icon}"></span> ${status.text}`,
            interpolate: true,
          },
        ],
        rows: [],
      },
    };
  },
  beforeMount() {

    let data2 = [];
    data2 = {
            'status': this.filterDP.state,
            'page':1
            };
    this.actGetRightPetition(data2).then(() =>{
        this.loadRows();                   
    })
    
    this.actGetCategories().then(() =>{
      this.categories.data.forEach(category => {
          this.opcionCategories.push({
            'value': category.id,
            'text': category.name
          });
      });
    });
  },
  computed: {
    ...mapState("modCore", ["user"]),
    ...mapState("modSettle", [
      "categories",
      "rightPetition",
      "loading"
      ]),

    countAllDemands() {
      return this.datatable.rows.length;
    },
  },
  methods: {
    ...mapActions("modSettle", [
      "actGetCategories",
      "actSaveRightPetition",
      "actGetRightPetition",
      "actFilterRightPetition"
    ]),

    getFilterDp(page = 1){
    let data2 = [];
    data2 = {
            'status': this.filterDP.state,
            'page':page,
            'filter': this.datatable.filter,
            'id':this.filterDP.id
            };
      
      //alert(JSON.stringify(data));
     this.actGetRightPetition(data2).then(() =>{
            this.datatable.rows = []
            this.loadRows();
          })
          .catch((response) => {
            this.error.flag = true;
            this.error.class = "is-invalid";
            this.error.message = "No se pudo conectar al servicio: error: "+response;
          });
    },

    fileSelected() {
      const dato = document.querySelector('#fileDocu');
      this.nameFile = dato.files[0].name;
    },

    saveRightPetition(){      
      var formData = new FormData();

      const fileSelected = document.querySelector('#fileDocu');
      formData.append("file", fileSelected.files[0]);
      formData.append("filing_number", this.numSettled);
      formData.append("category_id", this.ctgoria);

      this.actSaveRightPetition(formData).then(() =>{
        this.actGetRightPetition().then(() =>{
          this.datatable.rows = [];
          this.loadRows();
        });
        this.showModal("El derecho de petición se registró correctamente",0);
      }).catch((response) => {
        this.error.flag = true;
        this.error.class = "is-invalid";
        this.error.message = "Ocurrio un error al actualizar los datos: "+response;
      });      
    },

    filterPr(){
      this.datatable.rows = []
      console.log(this.filterDP)
      this.actFilterRightPetition(this.filterDP).then(() =>{
      this.loadRows();
      });
    },

    loadRows(){      
      let statusSubresponsible = [];
      let statusRequest = [];
      const dataService = this.rightPetition.data;

      for(let i=0; i<dataService.data.length; i++){
        //Estado Subresponsable
        if(dataService.data[i].subresponsible == null){
          statusSubresponsible[i] = {
            color: "#cccccc",
            text: "Sin Asignar",
          }
        }else{
          statusSubresponsible[i] = {
            color: "black",
            text: dataService.data[i].subresponsible,
          }
        }
      }

      for(let i=0; i<dataService.data.length; i++){
        //Estado solicitud
        if(dataService.data[i].status == "closed"){
          statusRequest[i] = {
            icon: "circle-check",
            text: "Cerrado",
          }
        }
        if(dataService.data[i].status == "open"){
          statusRequest[i] = {
            icon: "circle-clock",
            text: "Abierta",
          }
        }
        if(dataService.data[i].status == "pending"){
          statusRequest[i] = {
            icon: "circle-clock",
            text: "Pendiente",
          }
        }
        if(dataService.data[i].status == "closing"){
          statusRequest[i] = {
            icon: "eye",
            text: "Cerrando",
          }
        }        
      }
      
      //Orden Descendente      
      /*for(let i=dataService.data.length-1; i>=0; i--){
        this.datatableDP.rows.push({
          "id": dataService.data[i].id, 
          "dateDP": this.formatDateShow(dataService.data[i].created_at),//.substring(0, 10),
          "category": dataService.data[i].category_name,
          "uploader": dataService.data[i].core_role_name,
          "subresponsable": statusSubresponsible[i],
          "status": statusRequest[i]
        });
      }*/
      //Orden Acendente      
      for(let i=0; i<dataService.data.length; i++){
        this.datatable.rows.push({
          "id": dataService.data[i].id, 
          "dateDP": this.formatDateShow(dataService.data[i].created_at),//.substring(0, 10),
          "category": dataService.data[i].category_name,
          "uploader": dataService.data[i].core_role_name,
          "subresponsable": statusSubresponsible[i],
          "status": statusRequest[i]
        });
      }
    },

    funcion(row) {
      //alert(JSON.stringify(row));
      this.$router.push({ path: '/rightPetition/'+row.id })
    },

    formatDateShow(date){
      var d = new Date(date);
      var anno = d.getFullYear()+"";
      anno= anno.match(/\d{2}$/);
      var datestring = d.getDate()+" "+this.monthNames[d.getMonth()+1] +" "+ anno;
      return datestring;
    },

    showModal(msj,flag) { 
      this.msjModal = msj;
      this.flagPath = flag;
      this.$refs['my-modal'].show()
    },
    hideModal() {
      this.$refs['my-modal'].hide()
      if(this.flagPath == 1){
        this.$router.push({ path: '/solicitudes' });
      }
    },
  },
};
</script>

<style lang="scss">
#page-Settle {
  .data-table {
    tr {
      th {
        &:nth-child(1) {
          min-width: 120px;
        }
        &:nth-child(2) {
          min-width: 170px;
        }
        &:nth-child(3) {
          min-width: 110px;
        }
        &:nth-child(4) {
          min-width: 210px;
        }
        &:nth-child(5) {
          min-width: 110px;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
#page-Settle {
  .cont-search {
    label {
      font-size: 11px;
      color: #454545;
    }
    .cont-input {
      background: #1c3a4e;
      border-radius: 4px;
      padding: 1px;
      width: fit-content;
      float: left;

      .input-text {
        padding: 8px;
        min-width: 160px;
        border-radius: 4px;
        font-style: italic;
        font-weight: 300;
        font-size: 12px;
        color: #bbbbbb;
        border: 0 none;
        &:focus {
          outline: none;
        }
      }
      button {
        background: transparent;
        border: 0 none;
        color: #ffffff;
      }

      @media (min-width: 768px) {
        float: right;
      }
    }
  }

  .file-upload-img{
    width:360px;
    height:200px;
    border-style: dashed;
    text-align: center;
    display: flex;
    align-items: center;
  }
  .file-upload-img img{
      width:100%;
      height:100%;
  }
  input[type="file"]{
      opacity:0;
      filter:alpha(opacity=0);
      display:block;
      width:360px;
      height:200px;
      position:absolute;
      cursor:pointer;
  }



  .button1 {
    background: #E9ECEE;
    color: #1C3A4E;
    border:none;
    //border-radius: 50px;
    height: 24px;
    font-size: 12px;
    text-align: right !important;   
    padding-left: 5%;
    padding-right: 5%;
    &:hover {
      background: darken(#cddce6, 5);
    }
  }
  .button2 {
    background: #8d9092;
    color: #ffffff;
    border-color: #8d9092;
    font-family: "Poppins";
    border-radius: 100px;
    height: 42px;
    width: 220px;
    font-size: 14px;
    text-align: center !important;  
    padding-left: 2%;
    padding-right: 2%;
    &:hover {
      background: darken(#7a7c7e, 5);
    }
  }
  /*.div1 {
    border: 0px solid black;
    margin-top: 0px;
    margin-bottom: 0px;
    margin-right: 70px;
    margin-left: 70px;    
  }*/
  .tabla1{  
    border-radius: 5px;
    border: 3px solid #E9ECEE;
    border-color: #E9ECEE;  
    background: #E9ECEE;
    -moz-border-radius: 6px;
    border-collapse: separate;
    border-spacing: 0px;
    width: 90%;
    align-self: center;
  }
  .td1 {
    background: #E9ECEE;
    color: #1C3A4E;
    font-family: "Open Sans";
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    padding-left: 1%;
    padding-right: 1%;
    width: 100px;
    text-align: center;
  }
  .td2 {
    width: auto;
    background: #E9ECEE;
    color: #1C3A4E;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 14px;
    //width: 50px;
    text-align: left;
    padding-left: 4%;
    padding-right: 4%;
  }
  .td2 label p{
    font-size: 14px;
  }
  .td3 {
    background: #ffffff;
    color: #1C3A4E;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 80px;
    //width: 50px;
    text-align: center;
    padding-left: 4%;
    padding-right: 4%;
  }
  .td4 {
    background: #1C3A4E;
    color: #ffffff;
    font-family: "Open Sans";
    font-weight: bold;
    font-size: 12px;
    line-height: 25px;
    padding-left: 1%;
    padding-right: 1%;
    width: 100px;
    text-align: center;
  }
  .p2 {
    font-family: "Open Sans";
    font-style: normal;
    //font-weight: 600;
    font-size: 10px;
    line-height: 15px;
    color: #454545;
    text-align: left !important;
    
  }
  .collapsed > .when-opened,
      :not(.collapsed) > .when-closed {
          display: none;
      }
  .centerImg1 {
    width: 16px;
    height: 16px;
    top: 100%; 
    float: right;
  }
  .leftImg1 {
    width: 16px;
    height: 16px;
    vertical-align: middle;
  }
  /* Center the loader */
  #loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: 85px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }
  .radio{
    width: 40%;
    margin: 0 5%;
  }
  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  /* Add animation to "page content" */
  .animate-bottom {
    position: relative;
    -webkit-animation-name: animatebottom;
    -webkit-animation-duration: 1s;
    animation-name: animatebottom;
    animation-duration: 1s
  }

  @-webkit-keyframes animatebottom {
    from { bottom:-100px; opacity:0 } 
    to { bottom:0px; opacity:1 }
  }

  @keyframes animatebottom { 
    from{ bottom:-100px; opacity:0 } 
    to{ bottom:0; opacity:1 }
  }

  #myDiv {
    display: none;
    text-align: center;
  }
  .mycheck 
  { 
    vertical-align: middle;
    position: relative;
    bottom: 1px;
  }
  @media only screen and (max-width: 600px) {
  .td2 {
    width: 33%;
  }
}
}
</style>